module.exports = {"outlet":"Station","pricebook":"Pricebook","create_pricebook":"Create Pricebook","remove_pricebook":"Remove Pricebook","add_pricebook_products":"Add Pricebook Products","update_pricebook_products":"Update Pricebook Products","tags":"Sales Category","categories":"Loyalty Category","select_category":"Select Loyalty Category","category":"Loyalty Category","add_products_from_tags":"Add products from sales category","add_products_from_categories":"Add products from loyalty category"};


//////////////////
// WEBPACK FOOTER
// ./resources/lang/en_sentinel/pricebook.php
// module id = onB4
// module chunks = 50